export default "__VITE_ASSET__EA6YHZYx__"